<template>
<div class="mt_140">

    <ccMenu ref="cc_menu" v-bind:posicao=1></ccMenu>
    <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

    <div class="container">
    <div class="row">
    <div class="col-md-12">

      <div class="row">
        <div class="col-md-2">
          <ccMenuConta :num=8></ccMenuConta>
        </div>
        <div class="col-md-10 pt-0 p-4" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

          <!-- <ccContaConviteTopo v-bind:btn=1> </ccContaConviteTopo> -->

          <div class="text_branco mt-5 mb-4 text-center">
              Você deseja transferir todo seu saldo de convidados de R$ {{user.balance_convidado}} para seu saldo de jogo?
              <br><br>

              <button class="btn btn-outline-success btn-sm mb-3 p-2" @click="transferir()">
                <img :src='"../../assets/image/transfer.svg"' alt="Responsive image" width="18px"> &nbsp; Transferir
              </button>
          </div>
        </div>
      </div>

  </div>
  </div>
  </div>  

  <ccMensagem ref="cc_mensagem"></ccMensagem>
  
  <ccFooter></ccFooter>

</div>
</template>


<script>

import axios from 'axios';
import ccMenu from '../layout/menu.vue'
import ccMenuConta from '../conta/menu_conta.vue'
import ccContaTopo from '../conta/topo.vue'
import ccContaConviteTopo from '../conta/convite_topo.vue'
import {TheMask} from 'vue-the-mask'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccMensagem from '../cc_geral/mensagem.vue'
import ccFooter from '../layout/footer.vue'

export default {
  data () {
    return {
      titulo: 'TRANSFERIR SALDO CONVIDADO',

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],
      token: null,
    }
  },

  components: {ccMenu, TheMask, ccContaTopo, ccContaConviteTopo, ccLoading, ccMenuConta, ccFooter, ccMensagem},

  created()
  {
    document.title = 'Minha Conta: Convite Transferir - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    if (a == null){ this.user = {} }
    else{ this.user = a }

    this.token = this.user.access_token

    this.get_user_completo()
  },

  methods: {

    get_user_completo(){
      this.loading = true;
      var header = {'headers': {'x-access-token': this.token}};
      axios.get(this.base_url_api+'user/completo', header)
      .then(response => {

        this.user = response.data.resp

        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e);
        this.expluse_para_login()
      });
    },

    transferir(){

      this.loading = true;
      var header = {'headers': {'x-access-token': this.token, }};
      axios.get(this.base_url_api+'conta/convite/transferir', header)
      .then(response => {

        let r = response.data.resp

        var obj = {
          cor: 2,
          titulo: r,
          texto: null,
          btn1_ativo: false,
          btn1_cor: 3,
          btn1_texto: '',
          btn1_link: '',
          btn1_link_next: true,
          btn2_ativo: true,
          btn2_cor: 3,
          btn2_texto: 'VOLTAR',
          btn2_link: null,
          btn2_link_next: true,
        }

        this.$refs.cc_mensagem.receber_dados(obj);        

        // this.set_local_storate(this.user.balance, 0)
        // this.$router.push({ path: '/conta/convite/resumo', replace: true })

        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e);
        console.log(e)
        // this.expluse_para_login()
      });

    },

  }

}
</script>

<style scoped>
.card{
  background-color: #000000E3;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/conta/convite_transferir.vue